import { useTranslation } from "react-i18next";
import { TbPlayerPauseFilled } from "react-icons/tb";
import "./dunning.scss";

const DUNNING_MODIFIERS = ["grey", "green", "orange", "red", "blue"];
const DUNNING_KEYS = ["none", "friendly", "demanding", "final", "legal"] as const;
const DUNNING_BADGES: Record<number, string> = { 1: "M1", 2: "M2", 3: "M3" };

interface DunningProps {
    level: number;
    paused?: boolean;
}

export default function Dunning({ level, paused }: DunningProps) {
    const { t } = useTranslation();

    if (paused) {
        return (
            <span className="dunning dunning--paused">
                <TbPlayerPauseFilled size={13} />
                {t("filters.dunningLevels.paused")}
            </span>
        );
    }

    const modifier = DUNNING_MODIFIERS[level] ?? "grey";
    const key = DUNNING_KEYS[level];
    const label = key ? t(`filters.dunningLevels.${key}`) : t("filters.status.unknown");
    const badge = DUNNING_BADGES[level];
    return (
        <span className={`dunning dunning--${modifier}`}>
            {badge && <span className="dunning__badge">{badge}</span>}
            {label}
        </span>
    );
}
